import * as _ from 'underscore';

const defaultTimeout = 120;

export enum AppStepType {
   Form = 1,
   CheckIn = 2,
   ThankYou = 3,
   Photo = 4,
   Video = 5,
   QRScan = 6,
   QRAssign = 7,
   Languages = 8
}

const languagePage = {
   type: AppStepType.Languages,
   customFields: []
};

const checkinPage = {
   type: AppStepType.CheckIn,
   customFields: [],
   photoSettings: {
      cameraPosition: 'front'
   },
   timeout: defaultTimeout
};

const qrScanPage = {
   type: AppStepType.QRScan,
   customFields: [],
   photoSettings: {
      cameraPosition: 'front'
   },
   timeout: defaultTimeout
};

const formPage = {
   type: AppStepType.Form,
   customFields: [
      {
         key: 'firstName',
         label: {},
         type: 'text',
         required: true,
         sizeX: 2,
         sizeY: 3,
         minSizeX: 0,
         minSizeY: 3,
         row: 0,
         col: 0
      },
      {
         key: 'lastName',
         label: {},
         type: 'text',
         required: true,
         sizeX: 2,
         sizeY: 3,
         minSizeX: 0,
         minSizeY: 3,
         row: 3,
         col: 0
      },
      {
         key: 'email',
         label: {},
         type: 'text',
         required: true,
         sizeX: 2,
         sizeY: 3,
         minSizeX: 0,
         minSizeY: 3,
         row: 6,
         col: 0
      },
      {
         key: 'zip',
         label: {},
         type: 'text',
         required: false,
         sizeX: 2,
         sizeY: 3,
         minSizeX: 0,
         minSizeY: 3,
         row: 9,
         col: 0
      }
   ],
   timeout: defaultTimeout
};

const qrAssignPage = {
   type: AppStepType.QRAssign,
   customFields: [],
   photoSettings: {
      cameraPosition: 'front'
   },
   timeout: defaultTimeout
};

const photoPage = {
   type: AppStepType.Photo,
   customFields: [],
   photoSettings: {
      sendTo: [ 'email', 'sms' ],
      cameraPosition: null,
      type: 1,
      animationFrames: 3,
      animationDelay: 0.5
   },
   timeout: defaultTimeout
};

const videoPage = {
   type: AppStepType.Video,
   customFields: [],
   videoSettings: {
      sendTo: [ 'sms', 'email' ],
      captureDuration: 10,
      cameraPosition: 'rear',
      quality: '720p'
   },
   timeout: defaultTimeout
};

const thankYouPage = {
   type: AppStepType.ThankYou,
   customFields: [
      {
         key: '0',
         type: 'textLabel',
         required: false,
         sizeX: 2,
         sizeY: 4,
         minSizeX: 0,
         minSizeY: 4,
         row: 7,
         col: 0,
         description: {}
      }
   ],
   timeout: defaultTimeout
};

export const appPages = {
   [AppStepType.Languages]: languagePage,
   [AppStepType.CheckIn]: checkinPage,
   [AppStepType.QRScan]: qrScanPage,
   [AppStepType.Form]: formPage,
   [AppStepType.QRAssign]: qrAssignPage,
   [AppStepType.Photo]: photoPage,
   [AppStepType.Video]: videoPage,
   [AppStepType.ThankYou]: thankYouPage
};

export const appTemplates = {
   blank: {
      title: 'Blank',
      description: 'Create an experience from scratch',
      icons: [],
      pages: [
         thankYouPage,
      ]
   },

   registration: {
      title: 'Registration',
      description: 'Basic registration workflow',
      icons: ['fa-user'],
      pages: [
         formPage,
         thankYouPage
      ]
   },

   checkInReg: {
      title: 'Check-In & Registration',
      description: 'Basic check-in and registration workflow',
      icons: ['fa-qrcode', 'fa-user'],
      pages: [
         checkinPage,
         formPage,
         thankYouPage
      ]
   },

   regPhoto: {
      title: 'Registration, and Photo',
      description: 'Basic registration workflow, with photo capture module',
      icons: ['fa-user', 'fa-camera-retro'],
      pages: [
         formPage,
         photoPage,
         thankYouPage
      ]
   },

   regVideo: {
      title: 'Registration, and Video',
      description: 'Basic registration workflow, with video capture module',
      icons: ['fa-user', 'fa-video-camera'],
      invalid: false,
      pages: [
         formPage,
         videoPage,
         thankYouPage
      ]
   },

   checkInRegPhoto: {
      title: 'Check-In, Registration, and Photo',
      description: 'Basic check-in and registration workflow, with photo capture module',
      icons: ['fa-qrcode', 'fa-user', 'fa-camera-retro'],
      pages: [
         checkinPage,
         formPage,
         photoPage,
         thankYouPage
      ]
   },

   checkInRegVideo: {
      title: 'Check-In, Registration, and Video',
      description: 'Basic check-in and registration workflow, with video capture module',
      icons: ['fa-qrcode', 'fa-user', 'fa-video-camera'],
      invalid: false,
      pages: [
         checkinPage,
         formPage,
         videoPage,
         thankYouPage
      ]
   }
};
